// view candidate details
export const VIEW_CANDIDATE="VIEW_CANDIDATE"
export const VIEW_CANDIDATE_SUCCESS="VIEW_CANDIDATE_SUCCESS"
export const VIEW_CANDIDATE_ERROR="VIEW_CANDIDATE_ERROR"

// matching jobs 
export const MATCHING_JOBS="MATCHING_JOBS"
export const MATCHING_JOBS_SUCCESS="MATCHING_JOBS_SUCCESS"
export const MATCHING_JOBS_ERROR="MATCHING_JOBS_ERROR"

//Job Details
export const JOB_DETAIL="JOB_DETAIL"
export const JOB_DETAIL_SUCCESS="JOB_DETAIL_SUCCESS"
export const JOB_DETAIL_ERROR="JOB_DETAIL_ERROR"

//similar candidate 
export const SIMILAR_CADNIDATE="SIMILAR_CADNIDATE"
export const SIMILAR_CADNIDATE_SUCCESS="SIMILAR_CADNIDATE_SUCCESS"
export const SIMILAR_CADNIDATE_ERROR="SIMILAR_CADNIDATE_ERROR"

//candidate Details
export const CADNIDATE_DETAIL="CADNIDATE_DETAIL"
export const CADNIDATE_DETAIL_SUCCESS="CADNIDATE_DETAIL_SUCCESS"
export const CADNIDATE_DETAIL_ERROR="CADNIDATE_DETAIL_ERROR"

// set candidate job mapping 
export const CANDIDATE_JOB_MAPPING="CANDIDATE_JOB_MAPPING"
export const CANDIDATE_JOB_MAPPING_SUCCESS="CANDIDATE_JOB_MAPPING_SUCCESS"
export const CANDIDATE_JOB_MAPPING_ERROR="CANDIDATE_JOB_MAPPING_ERROR"

// get candidate job mapping 
export const GET_CANDIDATE_JOB_MAPPING="GET_CANDIDATE_JOB_MAPPING"
export const GET_CANDIDATE_JOB_MAPPING_SUCCESS="GET_CANDIDATE_JOB_MAPPING_SUCCESS"
export const GET_CANDIDATE_JOB_MAPPING_ERROR="GET_CANDIDATE_JOB_MAPPING_ERROR"

// remove candidate job mapping 
export const DELETE_CANDIDATE_JOB_MAPPING="DELETE_CANDIDATE_JOB_MAPPING"
export const DELETE_CANDIDATE_JOB_MAPPING_SUCCESS="DELETE_CANDIDATE_JOB_MAPPING_SUCCESS"
export const DELETE_CANDIDATE_JOB_MAPPING_ERROR="DELETE_CANDIDATE_JOB_MAPPING_ERROR"

//candidate active log
export const GET_CANDIDATE_ACTIVE_LOG = "GET_CANDIDATE_ACTIVE_LOG"
export const GET_CANDIDATE_ACTIVE_LOG_SUCCESS = "GET_CANDIDATE_ACTIVE_LOG_SUCCESS"
export const GET_CANDIDATE_ACTIVE_LOG_ERROR = "GET_CANDIDATE_ACTIVE_LOG_ERROR"